const initialState = {
  dataApiAmibo: [],
  loading: false,
  error: null
}

function reducer (state = initialState, action) {
  switch (action.type) {
    case 'DATAAPIAMIBO/FETCH':
      return {...state, dataApiAmibo: action.payload}
    case 'LOADING/CHANGELOADING':
      return {...state, loading: action.payload}
    case 'ERROR/CHANGEERROR':
      return {...state, error: action.payload}
    default:
      return state
  }
}

export default reducer